"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("./Style.css");
var _CMProw = _interopRequireDefault(require("./CMProw"));
var _react = _interopRequireWildcard(require("react"));
var _Translations = _interopRequireDefault(require("./translations/Translations"));
var _idbReactUiElements = require("@identitybuilding/idb-react-ui-elements");
var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
// import axios from 'axios'
var axios = require('axios');
var translation = new _Translations["default"]();

// Main component to render cmp"s
var DigitalDisplay = /*#__PURE__*/function (_Component) {
  _inherits(DigitalDisplay, _Component);
  var _super = _createSuper(DigitalDisplay);
  function DigitalDisplay(props) {
    var _this;
    _classCallCheck(this, DigitalDisplay);
    _this = _super.call(this, props);
    _this.state = {
      error: "",
      limit: 14,
      types: {
        pn: {
          data: []
        },
        cn: {
          data: []
        }
      },
      active_collection: _this.props.bpIndex ? _this.props.bpIndex : 0,
      active_sort: translation.getContent('recent_date', _this.props.lang),
      active_cmps: {}
    };
    return _this;
  }
  _createClass(DigitalDisplay, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;
      if (this.props.bpIndex !== prevProps.bpIndex) {
        this.setState({
          active_collection: this.props.bpIndex
        });
        setTimeout(function () {
          _this2.getData();
        }, 100);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;
      if (this.props.cmpsCollections.length === 0) {
        var data = '';
        var as_model = require('./models/DigitalDisplayModel')["default"];
        axios.get("https://management.100procentlokaal.be/core/api/business/".concat(this.props.id, "/cmps/?lang=").concat(this.props.lang)).then(function (res) {
          data = as_model(res.data, _this3.props.lang);
          _this3.setState({
            cmps_collections: data
          });
          _this3.props.setCmpsCollections(data);
          _this3.getData();
        })["catch"](function (error) {
          return console.log(error);
        });
      } else {
        this.setState({
          cmps_collections: this.props.cmpsCollections
        });
        this.getData();
      }
    }
  }, {
    key: "getData",
    value: function getData() {
      var copy = _objectSpread({}, this.state.types);
      var lang = this.props.lang;
      var _this$state = this.state,
        active_sort = _this$state.active_sort,
        active_collection = _this$state.active_collection;
      var active_cmps = this.props.cmpsCollections.length > 0 ? this.props.cmpsCollections[active_collection].cmps : this.state.cmps_collections[active_collection].cmps;
      this.setState({
        active_cmps: active_cmps
      });
      // Sorting function
      var sortedCmps = active_cmps.slice().sort(function (a, b) {
        // afterwards, sort on weight
        if (a.weight > b.weight) {
          return 1;
        }
        if (a.weight < b.weight) {
          return -1;
        }
        var afrom = a.from.split('-');
        var bfrom = b.from.split('-');
        var adate = new Date(afrom[2], Number(afrom[1] - 1), afrom[0]);
        var bdate = new Date(bfrom[2], Number(bfrom[1] - 1), bfrom[0]);
        // sort on recent date
        if (active_sort === translation.getContent("recent_date", lang)) {
          if (adate > bdate) {
            return -1;
          }
          if (adate < bdate) {
            return 1;
          }
        }

        // // sort on oldest date
        if (active_sort === translation.getContent("oldest_date", lang)) {
          if (adate > bdate) {
            return 1;
          }
          if (adate < bdate) {
            return -1;
          }
        }

        // // sort alphabetical
        if (active_sort === translation.getContent("a_z", lang)) {
          if (a.title > b.title) {
            return 1;
          }
          if (a.title < b.title) {
            return -1;
          }
        }

        // sort unalphabetical
        if (active_sort === translation.getContent("z_a", lang)) {
          if (a.title > b.title) {
            return -1;
          }
          if (a.title < b.title) {
            return 1;
          }
        }
      });
      // remove the current value
      copy.cn.data = [];
      copy.pn.data = [];
      for (var i = 0; i < sortedCmps.length; i++) {
        copy[sortedCmps[i].type === "promo" ? "pn" : "cn"].data.push(sortedCmps[i]);
      }
      this.setState({
        types: copy
      });
    }
  }, {
    key: "setData",
    value: function setData(data, e, key) {
      var copy = this.state.types;
      copy[key].data = data;
      copy[key].loaded = e;
      this.setState({
        types: copy
      });
    }
  }, {
    key: "sortData",
    value: function sortData() {
      var copy_cn = _toConsumableArray(this.state.types.cn.data);
      var copy_pn = _toConsumableArray(this.state.types.pn.data);
      var active_sort = this.state.active_sort;
      var copy = _objectSpread({}, this.state.types);
      var data = copy_cn.concat(copy_pn);
      var lang = this.props.lang;
      var sortedCmps = data.slice().sort(function (a, b) {
        // sort on recent date
        var afrom = a.from.split('-');
        var bfrom = b.from.split('-');
        var adate = new Date(afrom[2], Number(afrom[1] - 1), afrom[0]);
        var bdate = new Date(bfrom[2], Number(bfrom[1] - 1), bfrom[0]);
        // sort on recent date
        if (active_sort === translation.getContent("recent_date", lang)) {
          if (adate > bdate) {
            return -1;
          }
          if (adate < bdate) {
            return 1;
          }
        }

        // // sort on oldest date
        if (active_sort === translation.getContent("oldest_date", lang)) {
          if (adate > bdate) {
            return 1;
          }
          if (adate < bdate) {
            return -1;
          }
        }

        // // sort alphabetical
        if (active_sort === translation.getContent("a_z", lang)) {
          if (a.title > b.title) {
            return 1;
          }
          if (a.title < b.title) {
            return -1;
          }
        }

        // sort unalphabetical
        if (active_sort === translation.getContent("z_a", lang)) {
          if (a.title > b.title) {
            return -1;
          }
          if (a.title < b.title) {
            return 1;
          }
        }

        // afterwards, sort on weight
        if (a.weight > b.weight) {
          return 1;
        }
        if (a.weight < b.weight) {
          return -1;
        }
      });

      // remove the current value
      copy.cn.data = [];
      copy.pn.data = [];

      // fill it with the sorted value
      for (var i = 0; i < sortedCmps.length; i++) {
        copy[sortedCmps[i].type === "promo" ? "pn" : "cn"].data.push(sortedCmps[i]);
      }
      this.setState({
        types: copy
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props = this.props,
        lang = _this$props.lang,
        theme = _this$props.theme;
      return /*#__PURE__*/_react["default"].createElement("section", {
        id: "digitalDisplay",
        className: "".concat(theme ? theme : "light")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "sectionWrapper"
      }, /*#__PURE__*/_react["default"].createElement("h2", null, translation.getContent("package_title", lang)), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          marginBottom: '15px',
          justifyContent: 'space-between'
        }
      }, this.state.cmps_collections && this.state.cmps_collections.length > 1 && this.props.bpIndex === undefined && /*#__PURE__*/_react["default"].createElement("div", {
        className: "cmp_buttons"
      }, this.state.cmps_collections.map(function (collection, index) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: index === _this4.state.active_collection ? "active" : "",
          key: index,
          onClick: function onClick() {
            _this4.setState({
              active_collection: _this4.props.bpIndex ? _this4.props.bpIndex : index
            });
            setTimeout(function () {
              _this4.getData();
            }, 100);
          }
        }, collection.title);
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "orderField"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "order_title"
      }, translation.getContent('sort', lang), ":"), /*#__PURE__*/_react["default"].createElement(_idbReactUiElements.OsnSelect, {
        active: this.state.active_sort,
        options: [translation.getContent("recent_date", lang), translation.getContent("oldest_date", lang), translation.getContent("a_z", lang), translation.getContent("z_a", lang)],
        onChange: function onChange(e) {
          _this4.setState({
            active_sort: e
          });
          setTimeout(function () {
            _this4.sortData();
          }, 100);
        }
      }))), this.state.types && Object.entries(this.state.types).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        return value.data.length > 0 && /*#__PURE__*/_react["default"].createElement(_CMProw["default"], {
          value: value,
          key: key,
          lang: lang,
          limit: _this4.state.limit
          // stateHandler={(e) => this.setState(prevState => ({ pn: { ...prevState.types.pn, loaded: e } }))}
          ,
          stateHandler: function stateHandler(data, e) {
            return _this4.setData(data, e, key);
          },
          type: key,
          id: _this4.state.cmps_collections && _this4.state.cmps_collections.id ? _this4.state.cmps_collections.id : '',
          name: _this4.props.name,
          url: _this4.props.url,
          url_catalogue: _this4.props.url_catalogue,
          url_promonetwork: _this4.props.url_promonetwork
        });
      })));
    }
  }]);
  return DigitalDisplay;
}(_react.Component);
exports["default"] = DigitalDisplay;